import React from 'react';

interface IconPdfProps {
    iconClasses?: string;
}

const IconPdf: React.FC<IconPdfProps> = ({ iconClasses }) => {
    return (
        <svg
            width="20"
            height="20"
            viewBox="0 0 20 20"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            className={`icon icon-pdf ${iconClasses ?? ''}`}
            aria-hidden="true"
        >
            <path
                d="M5.25 2.75h6.75L15.25 5.5V16.25H5.25V2.75Z"
                stroke="currentColor"
                strokeWidth="1.5"
                strokeLinejoin="round"
            />
            <path
                d="M12 2.75V5.5h3.25"
                stroke="currentColor"
                strokeWidth="1.5"
                strokeLinejoin="round"
            />
            <path
                d="M7.25 9.25h5.5M7.25 11.75h3.75"
                stroke="currentColor"
                strokeWidth="1.5"
                strokeLinecap="round"
            />
            <path
                d="M7.1 14.35h1.05c.55 0 .95-.4.95-.9 0-.55-.4-.95-.95-.95H7.1v2.35Zm0-1.05h1c.2 0 .35-.15.35-.35 0-.2-.15-.35-.35-.35H7.1v.7Zm2.65 1.05h.95l.55-2.35h-.85l-.35 1.55-.35-1.55h-.85l.55 2.35Zm2.2 0h.85v-1.65h.95v-.7h-.95v-.35h1.15v-.65h-2.1v2.35Z"
                fill="currentColor"
            />
        </svg>
    );
};

export default IconPdf;
